import React from "react";

import KanbanColumnHeaderView from "./KanbanColumnHeaderView";
import { useKanbanColors } from "@/features/player-kanban/hooks/useKanbanColors";

/**
 *
 */
interface KanbanColumnHeaderContainerProps {
  title: string;
  isEditingTitle: boolean;
  editTitleValue: string;
  onSaveTitleEdit: () => void;
  onCancelTitleEdit: () => void;
  onTitleChange: (value: string) => void;
}

/**
 * Container component for the kanban column header title.
 *
 * SE-6489: rename and delete are no longer surfaced here as inline icons —
 * they are rows in the stage overflow menu (`StageOptionsMenu`), so the
 * permission flags and their handlers are owned by that menu instead. This
 * component is now just the title, in its display and inline-edit states.
 * @param root0 - The component props
 * @param root0.title - The current title text displayed in the column header
 * @param root0.isEditingTitle - Whether the title is currently in edit mode
 * @param root0.editTitleValue - The temporary value of the title while editing
 * @param root0.onSaveTitleEdit - Callback invoked when user saves the edited title
 * @param root0.onCancelTitleEdit - Callback invoked when user cancels title editing
 * @param root0.onTitleChange - Callback invoked when the title input value changes
 */
const KanbanColumnHeaderContainer = ({
  title,
  isEditingTitle,
  editTitleValue,
  onSaveTitleEdit,
  onCancelTitleEdit,
  onTitleChange,
}: KanbanColumnHeaderContainerProps) => {
  const colors = useKanbanColors();

  return (
    <KanbanColumnHeaderView
      title={title}
      isEditingTitle={isEditingTitle}
      editTitleValue={editTitleValue}
      colors={colors}
      onSaveTitleEdit={onSaveTitleEdit}
      onCancelTitleEdit={onCancelTitleEdit}
      onTitleChange={onTitleChange}
    />
  );
};

export default KanbanColumnHeaderContainer;
